export type WPContent = {
	readonly titleSelectAHouse: string;
	readonly textSelectAHouse: string;
	readonly titleAvailability: string;
	readonly textAvailability: string;
	readonly titleSummary: string;
	readonly textSummary: string;
	readonly titlePersonalDetails: string;
	readonly textPersonalDetails: string;
	readonly termsLink: WPACFLink;
	readonly titleThankYouMessage: string;
	readonly textThankYouMessage: string;
};

export type WPACFLink = {
	url: string;
	title: string;
	target: string;
};

export type WPHousePosts = WPHousePost[];

export type WPHousePost = {
	readonly id: number;
	readonly title: string;
	readonly booking: {
		description: string;
		maxPersons: number;
	};
	readonly link: string;
	readonly allowNewReservations?: boolean;
};

export type WPContentSource = {
	readonly title_select_a_house: string;
	readonly text_select_a_house: string;
	readonly title_availability: string;
	readonly text_availability: string;
	readonly title_summary: string;
	readonly text_summary: string;
	readonly title_personal_details: string;
	readonly text_personal_details: string;
	readonly terms_link: WPACFLinkSource;
	readonly title_thank_you_message: string;
	readonly text_thank_you_message: string;
};

export type WPACFLinkSource = {
	url: string;
	title: string;
	target: string;
};

export type WPHousePostsSource = WPHousePostSource[];

export type WPHousePostSource = {
	readonly id: number;
	readonly title: string;
	readonly booking: {
		description: string;
		max_persons: number;
	};
	readonly link: string;
	readonly allow_new_reservations?: boolean;
};

export function wpContentDataFormatter( content: WPContentSource ): WPContent {
	return {
		titleSelectAHouse: content.title_select_a_house,
		textSelectAHouse: content.text_select_a_house,
		titleAvailability: content.title_availability,
		textAvailability: content.text_availability,
		titleSummary: content.title_summary,
		textSummary: content.text_summary,
		titlePersonalDetails: content.title_personal_details,
		textPersonalDetails: content.text_personal_details,
		termsLink: {
			url: content.terms_link.url,
			title: content.terms_link.title,
			target: content.terms_link.target,
		},
		titleThankYouMessage: content.title_thank_you_message,
		textThankYouMessage: content.text_thank_you_message,
	};
}

export function wpPostsDataFormatter( posts: WPHousePostsSource ): WPHousePosts {
	return posts.map( ( post ) => {
		return {
			id: post.id,
			title: post.title,
			booking: {
				description: post.booking.description,
				maxPersons: post.booking.max_persons,
			},
			link: post.link,
			allowNewReservations: post.allow_new_reservations,
		};
	} );
}
